export const EMAIL_STATES = {
  SCHEDULED: 0,
  IN_PROGRESS: 1,
  COMPLETED: 2,
  FAILED: 4
};
